
<template>
  <div>
    <el-dialog
      title="导入"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="close"
    >
      <div class="upload-center">
        <input
          type="file"
          @change="fileChange()"
          ref="imFile"
          style="display: none"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,"
        />
        <div class="tipClass">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="选择文件" prop="fileSrc">
              <div class="selectFile">
                <el-button size="small" type="text" @click="uploadFile()"
                  >浏览...</el-button
                >
                <p
                  style="color: #fff"
                  v-text="fileSrc === '' ? '未选择文件' : fileSrc"
                ></p>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                style="margin-left: 10px"
                v-preventReClick="5000"
                :disabled="disabled"
                size="small"
                type="success"
                @click="uploadExcel()"
              >
                上传
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="tipClass">
          <p>
            仅支持.xls与.xlsx文件。
            <el-button
              type="text"
              @click="downTemplate('亚马逊退款导入模板', '/Amazon/Refund/template')"
              >下载模板</el-button
            >
          </p>
        </div>
        <!-- <div class="tipClass" v-if="isTips">
          <p>1.请按照模板填写表格内容，所有字段均为必填项；</p>
          <p>2.同一（仓库+SKU）若重复导入，后面的数据会覆盖之前的。</p>
        </div> -->
        <div
          class="tipClass1"
          v-if="!isTips"
          v-loading="loading"
          element-loading-text="拼命上传中"
          element-loading-spinner="el-icon-loading"
        >
          <p class="fontColor">
            <i class="el-icon-tickets" style="color: #67c23a"></i>
            <span>共处理：{{ tips.handleNum }} 条</span>
          </p>
          <p class="fontColor">
            <i class="el-icon-success" style="color: #67c23a"></i>
            <span>导入成功：{{ tips.successNum }} 条</span>
          </p>
          <p class="fontColor">
            <i class="el-icon-error" style="color: #f56c6c"></i>
            <span>导入失败：{{ tips.errorNum }} 条</span>
            <el-button
              v-if="tips.errorNum > 0"
              style="margin-left: 50px"
              size="mini"
              type="primary"
              @click="downLoad('亚马逊退款导入失败数据', tips.errorFileUrl)"
            >
              下载失败结果</el-button
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 退款批量导入弹窗
 * 功能：选择 Excel 文件上传并展示导入处理/成功/失败条数，可下载模板与失败结果。
 * 备注：downTemplate 硬编码外网 IP 地址（8.129.24.175）下载模板，不规范；exportUrl/isUpload/activeName/list 等字段未使用。
 */
import { uploadAmazonRefund, exportExcel } from "@/api/user";

export default {
  data() {
    return {
      // 上传处理状态
      loading: false,
      // 按钮禁用状态
      disabled: false,
      // 是否显示模板提示区域
      isTips: true,
      // 弹窗显示状态
      dialogVisible: true,
      // 未使用
      isUpload: false,
      // 选择的文件列表
      file: [],
      // 文件名列表
      list: {
        fileName: "",
      },
      // 文件流
      formData: new FormData(),
      // 文件 input 引用
      imFile: "",
      // 当前选择的文件对象
      files: null,
      // 未使用
      activeName: "first",
      // 已选文件完整名称
      fileSrc: "",
      // 导入结果统计（处理/成功/失败条数、失败文件地址）
      tips: {},
      // 模板下载地址（未使用，实际下载走 downTemplate 中的硬编码地址）
      exportUrl: "/Amazon/Refund/template",
    };
  },
  methods: {
    /** 关闭弹窗并重置导入状态，通知父组件 */
    close() {
      this.isTips = true;
      this.tips = {};
      this.dialogVisible = false;
      this.$emit("isShowEdit");
      //   this.$emit("getList");
    },
    /** 下载导入模板（注意：模板点击传入的参数未使用，实际硬编码外网 IP 地址下载，不规范） */
    downTemplate() {
      var downloadElement = document.createElement("a");
      // 直接通过链接下载
      downloadElement.href =
        "http://8.129.24.175:8080/yy-crm/template/亚马逊退款导入模板.xlsx";
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
    },
    /** 下载导入失败结果文件（导出为 CSV）
     * @param {String} fileName 下载文件名（不含扩展名）
     * @param {String} url 导出接口地址
     */
    downLoad(fileName, url) {
      exportExcel("", url)
        .then((result) => {
          let blob = new Blob([result], {
            type: "text/plain;charset=utf-8;",
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          //   文件名显示有误
          downloadElement.download = fileName + ".csv"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {});
    },
    // 文件改变
    fileChange() {
      this.getFile();
      this.fileSrc = this.files.name;
      this.$refs.imFile.value = ""; // 清空
    },
    /** 从文件 input 中取出所选文件 */
    getFile() {
      let obj = this.$refs.imFile;
      this.files = obj.files[0];
    },
    // 批量导入按钮事件
    uploadExcel() {
      if (this.fileSrc === "") return this.$message.warning(`请选择表格导入`);
      this.importFile();
      this.loading = true;
      this.isTips = false;
      uploadAmazonRefund(this.formData).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          this.tips = res.data;
          this.files = null;
          this.fileSrc = "";
          this.formData.delete("file");
          this.$emit("getList");
        }
      });
    },
    //导入按钮
    uploadFile() {
      // this.formData.delete('excel')
      this.$refs.imFile.click();
    },
    // 导入 excel 流
    importFile() {
      this.formData.append("file", this.files);
    },
  },
};
</script>
<style type="text/css" scoped>
.el-form {
  text-align: left;
}
.selectFile {
  display: flex;
  background-color: #909399;
  padding: 0px 8px;
  border-radius: 5px;
}
.tipClass,
.tipClass1 {
  width: 400px;
  margin: 0px auto;
}
.tipClass p {
  text-align: left;
  font-size: 12px;
  color: #8f949c;
}
.tipClass1 p {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
}
.tipClass1 i {
  margin-right: 8px;
}
</style>